"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultLayoutPage = void 0;
var _components = require("../../components");
var _internal = require("./internal");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Represents a default layout component with standard features used in most apps.
 *
 *
 * @param props - Props for the {@link DefaultLayoutPageProps} component.
 * @returns A JSX element representing the DefaultLayout.
 *
 * @remarks
 * This component is composed of `DefaultLayoutPage`, `DefaultLayoutContent` (`TopArea`, `LanguageSwitcher`, `Footer`, `Chat`)
 * @example
 * ```tsx
 * <DefaultLayout>
 *   <PageContent />
 * </DefaultLayout>
 * ```
 */
const DefaultLayoutPage = ({
  page,
  layout,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Page, {
  ...page,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_internal.DefaultLayout, {
    ...layout,
    children: children
  })
});
exports.DefaultLayoutPage = DefaultLayoutPage;
